import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useState } from 'react';
import cx from 'classnames';
import { Input } from 'reactstrap';
import { Button, SFxButtonGroup } from '../../../../Basic/Button';
import Modal from '../../../../Basic/Modal';
import { validateVoucherCode, consumeVoucherCode } from '../../../api/subscriptionManagement.api';

var RedeemVoucherModal = function RedeemVoucherModal(_ref) {
  var isOpen = _ref.isOpen,
      setIsOpen = _ref.setIsOpen,
      onToggle = _ref.onToggle,
      refreshCallback = _ref.refreshCallback,
      translate = _ref.translate;

  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      voucherCode = _useState2[0],
      setVoucherCode = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      redeemSuccess = _useState4[0],
      setRedeemSuccess = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isSubmitting = _useState6[0],
      setSubmit = _useState6[1];

  var _useState7 = useState(''),
      _useState8 = _slicedToArray(_useState7, 2),
      tipType = _useState8[0],
      setTipType = _useState8[1];

  var onChange = function onChange(e) {
    var value = e.target.value;
    setVoucherCode(value);
  };

  var onClose = function onClose() {
    setIsOpen(false);
  };

  var onSubmit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var validationRes, consumeRes;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setSubmit(true);
              _context.prev = 1;
              _context.next = 4;
              return validateVoucherCode(voucherCode);

            case 4:
              validationRes = _context.sent;

              if (!(validationRes.data !== true)) {
                _context.next = 7;
                break;
              }

              throw new Error('Invalid voucher code');

            case 7:
              _context.next = 9;
              return consumeVoucherCode(voucherCode);

            case 9:
              consumeRes = _context.sent;

              if (!(consumeRes.status !== 200)) {
                _context.next = 12;
                break;
              }

              throw new Error('Voucher code consume failed');

            case 12:
              setTipType('success');
              refreshCallback && refreshCallback();
              _context.next = 20;
              break;

            case 16:
              _context.prev = 16;
              _context.t0 = _context["catch"](1);
              console.error(_context.t0);
              setTipType('unknown');

            case 20:
              _context.prev = 20;
              setRedeemSuccess(true);
              setSubmit(false);
              return _context.finish(20);

            case 24:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 16, 20, 24]]);
    }));

    return function onSubmit() {
      return _ref2.apply(this, arguments);
    };
  }();

  var quoteForm = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "voucher-title"
  }, translate('SFxAccountSettingsConfirmsubscriptionMessage')), /*#__PURE__*/React.createElement("p", {
    className: "content"
  }, translate('SFxAccountSettingsEnterVoucherCode')), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Input, {
    type: "text",
    className: "code-input",
    value: voucherCode,
    onChange: onChange
  })));
  var quoteFormFooter = /*#__PURE__*/React.createElement("div", {
    className: "voucher-footer"
  }, /*#__PURE__*/React.createElement("div", {
    className: "operation-area"
  }, /*#__PURE__*/React.createElement(SFxButtonGroup, null, /*#__PURE__*/React.createElement(Button, {
    btype: "basic",
    onClick: onClose
  }, translate('SFxAccountSettingsCancelButtonText')), /*#__PURE__*/React.createElement(Button, {
    disabled: !voucherCode || isSubmitting,
    onClick: onSubmit
  }, translate('SFxAccountSettingsSubmitButtonText')))));

  var quoteSuccessTips = function quoteSuccessTips(tipType) {
    var tip = redeemResults.find(function (result) {
      return result.type === tipType;
    }) || redeemResults.find(function (result) {
      return result.type === 'unknown';
    });
    return /*#__PURE__*/React.createElement("div", {
      className: "quote-success"
    }, /*#__PURE__*/React.createElement("h2", {
      className: "voucher-title"
    }, tip && translate(tip.title)), /*#__PURE__*/React.createElement("p", {
      className: "content"
    }, tip && translate(tip.tips)));
  };

  return /*#__PURE__*/React.createElement(Modal, {
    isOpen: isOpen,
    centered: true,
    backdrop: "static",
    className: cx('dialogModalWrap', 'voucher-modal'),
    toggle: onToggle,
    title: redeemSuccess ? translate('SFxAccountSettingsVoucherModalTitlewhenSuccess') : translate('SFxAccountSettingsVoucherModalTitle'),
    footer: redeemSuccess ? null : quoteFormFooter
  }, redeemSuccess ? quoteSuccessTips(tipType) : quoteForm);
};

var redeemResults = [{
  type: 'success',
  title: 'SFxAccountSettingsRedeemResultsSuccessTitle',
  tips: 'SFxAccountSettingsRedeemResultsSuccessMsg'
}, {
  type: 'expired',
  title: 'SFxAccountSettingsRedeemResultsExpiredTitle',
  tips: 'SFxAccountSettingsRedeemResultsExpiredMsg'
}, {
  type: 'missing',
  title: 'SFxAccountSettingsRedeemResultsMissingTitle',
  tips: "SFxAccountSettingsRedeemResultsMissingMsg"
}, {
  type: 'used',
  title: 'SFxAccountSettingsRedeemResultsUsedTitle',
  tips: 'SFxAccountSettingsRedeemResultsUsedMsg'
}, {
  type: 'unknown',
  title: 'SFxAccountSettingsRedeemResultsUnknownTitle',
  tips: 'SFxAccountSettingsRedeemResultsUnknownMsg'
}];
export default RedeemVoucherModal;